export default __webpack_public_path__ + "static/media/PDF-Placeholder.bdc11be8.png";